  document.addEventListener('DOMContentLoaded', function() {
    // 使用选择器来确保我们只初始化当前页面上的这个特定模块
    const hubElement = document.querySelector('.product-video-hub');
    if (!hubElement || hubElement.dataset.initialized) return;
    hubElement.dataset.initialized = 'true';
  
    // ===================================================================
    // == 在这里管理您的视频和产品数据 ==
    // ===================================================================
    const allVideos = [
      { id: 'emtU9n5Xc88', title: 'How it Works: OA Knee Brace Booster for Arthritis Meniscus Ligament Injury & Knock knee correction' },
      { id: 'tYfSDmqPfrI', title: 'Hinged ROM Post Op Elbow Brace - Stabilizer Splint Arm Injury Recover by Orthomen' },
      { id: 'SMq3chmJdw0', title: 'How It Works: OA Unloader Knee Brace For Osteoarthritis , Bone-On-Bone Knee Pain by Orthomen' },
      { id: 'UpwHHhy0Lic', title: 'Hyper-X TLSO Jewett Hyperextension Back Brace Orthosis - Fitting Instructions' },
      { id: 'MNdEaPR3JCU', title: 'Hip Abduction Brace, Orthomen Post op Hip Protector Stabilizer Compression Support for Joint Pain' },
      { id: '9bkA98Mg1rU', title: 'Cervical Collar by Orthomen - Adjustable Soft Neck Brace - Relieves Pain and Pressure in Spine' }
    ];
  
    const products = [
      { url: '/products/rom-arm-elbow-brace', img: 'https://fzjbub-wk.myshopify.com/cdn/shop/files/EL092.jpg', title: 'Post OP Elbow Brace', price: '$69.99' },
      { url: '/products/rom-air-cam-walker-boot', img: 'https://fzjbub-wk.myshopify.com/cdn/shop/files/WK001.jpg', title: 'Air Cam Walker Boot', price: '$41.38' },
      { url: '/products/spine-lower-back-brace-lumbar-orthosis', img: 'https://fzjbub-wk.myshopify.com/cdn/shop/files/LumbarOrthosisforLowerBackPain_SpineSportBackBrace_3.jpg', title: 'Spine Sport Back Brace - Lumbar Orthosis for Lower Back Pain', price: '$59.99' },
      { url: '/products/rom-hip-brace', img: 'https://fzjbub-wk.myshopify.com/cdn/shop/files/HIP314.jpg', title: 'Abduction Hip Brace, Post-Op Rom Hip Stabilizer Brace', price: '$217.97' },
      { url: '/products/hinged-knee-brace', img: 'https://fzjbub-wk.myshopify.com/cdn/shop/files/KN095.jpg', title: 'Hinged Post Op Knee Brace', price: '$96.97' },
      { url: '/products/drop-foot-brace', img: 'https://fzjbub-wk.myshopify.com/cdn/shop/files/L.jpg', title: 'Drop Foot Brace', price: '$34.99' }
    ];
    
    const VIDEOS_PER_PAGE = 6;
    let currentPage = 0;
    let currentlyPlayingId = null;
  
    const playerContainer = hubElement.querySelector('#main-video-player');
    const playlistContainer = hubElement.querySelector('#video-playlist');
    const carouselContainer = hubElement.querySelector('#product-carousel');
    const carouselTrack = hubElement.querySelector('#product-carousel-track');
    const arrowLeft = hubElement.querySelector('#carousel-arrow-left');
    const arrowRight = hubElement.querySelector('#carousel-arrow-right');
    const footer = hubElement.querySelector('#playlist-footer');
    const loadMoreBtn = hubElement.querySelector('#load-more-videos');
  
    function loadVideo(videoId) {
      currentlyPlayingId = videoId;
      playerContainer.innerHTML = `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      updateActivePlaylistItem();
    }
    
    function updateActivePlaylistItem() {
        const allItems = playlistContainer.querySelectorAll('.playlist-item');
        allItems.forEach(item => {
            if (item.dataset.videoId === currentlyPlayingId) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }
  
    function renderPlaylist() {
      playlistContainer.innerHTML = allVideos.map(video => `
        <div class="playlist-item" data-video-id="${video.id}">
          <div class="playlist-thumbnail-wrapper">
            <img src="https://i.ytimg.com/vi/${video.id}/mqdefault.jpg" alt="${video.title}" loading="lazy">
            <div class="now-playing-indicator">Now playing</div>
          </div>
          <div class="playlist-info">
            <div class="title">${video.title || 'Video Title'}</div>
            <div class="user">${video.user || 'Orthomen US'}</div>
          </div>
        </div>
      `).join('');
    }
  
    function generateProductCarousel() {
      if (products.length === 0) return;
      carouselContainer.style.display = 'block';
      carouselTrack.innerHTML = products.map(product => `
        <div class="product-card">
          <a href="${product.url}">
            <img src="${product.img}" alt="${product.title}" loading="lazy">
            <div class="product-title">${product.title}</div>
            <div class="product-price">${product.price}</div>
          </a>
        </div>
      `).join('');
    }
    
    // --- Initialize ---
    if (allVideos.length > 0) {
      renderPlaylist();
      loadVideo(allVideos[0].id); 
    }
  
    if (products.length > 0) {
      generateProductCarousel();
    }
  
    // --- Event Listeners ---
    playlistContainer.addEventListener('click', (e) => {
      const item = e.target.closest('.playlist-item');
      if (item) {
        const videoId = item.dataset.videoId;
        if (videoId !== currentlyPlayingId) {
          loadVideo(videoId);
        }
      }
    });
  
    arrowLeft.addEventListener('click', () => carouselTrack.scrollBy({ left: -200, behavior: 'smooth' }));
    arrowRight.addEventListener('click', () => carouselTrack.scrollBy({ left: 200, behavior: 'smooth' }));
  });